import { BusEvent } from '@web/common';

export class AdminBoxChangedBusEvent extends BusEvent {}
